import * as React from "react";
import * as React44ms from "../../../Util/form-utils/react-44ms";

import { DeliveryDetailsForm } from "../../model";

interface DeliveryDetailsFormRefConsumerInterface {
  formRef: React44ms.Api.TypedRef<DeliveryDetailsForm> | null;
}
const defaultValue =
  {} as unknown as DeliveryDetailsFormRefConsumerInterface;
const DeliveryDetailsFormRefContext = React.createContext(defaultValue);

interface DeliveryDetailsFormRef_ControllerInterface {
  setDeliveryDetailsFormRef: (
    formRef: React44ms.Api.TypedRef<DeliveryDetailsForm> | null
  ) => void;
}
const controllerDefaultValue =
  {} as unknown as DeliveryDetailsFormRef_ControllerInterface;
const DeliveryDetailsFormRef_ControllerContext =
  React.createContext(controllerDefaultValue);

export const DeliveryDetailsFormRefProvider: React.FunctionComponent = (
  props
) => {
  const [formRef, setFormRef] =
    React.useState<React44ms.Api.TypedRef<DeliveryDetailsForm> | null>(null);

  const value: DeliveryDetailsFormRefConsumerInterface = React.useMemo(
    () => ({ formRef }),
    [formRef]
  );
  const controllerValue: DeliveryDetailsFormRef_ControllerInterface =
    React.useMemo(
      () => ({
        setDeliveryDetailsFormRef: setFormRef,
      }),
      []
    );

  return (
    <DeliveryDetailsFormRefContext.Provider value={value}>
      <DeliveryDetailsFormRef_ControllerContext.Provider
        value={controllerValue}
      >
        {props.children || []}
      </DeliveryDetailsFormRef_ControllerContext.Provider>
    </DeliveryDetailsFormRefContext.Provider>
  );
};

export const useDeliveryDetailsFormRef = () => {
  const context = React.useContext(DeliveryDetailsFormRefContext);
  if (context === defaultValue) {
    throw new Error(
      "useDeliveryDetailsFormRef must be used within a DeliveryDetailsFormRefProvider"
    );
  }
  return context;
};

export const useDeliveryDetailsFormRef_asController = () => {
  const context = React.useContext(DeliveryDetailsFormRef_ControllerContext);
  if (context === controllerDefaultValue) {
    throw new Error(
      "useDeliveryDetailsFormRef_asController must be used within a DeliveryDetailsFormRefProvider"
    );
  }
  return context;
};
